import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProductTopSection from '../../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../../components/Sangjo-Ujieon/ProductSubHeading';
import FuneralTabPC from '../../../../components/Sangjo-Ujieon/FuneralTabPC';

const FuneralInformationReligiousPC = () => {
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    navigate(route);
  };

  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="장례정보" />

        <FuneralTabPC />

        {/* Main Content */}
        <div className="funeral-information-religious-main-content">
          <div className="funeral-information-religious-page-content funeral-information-religious-container">

            {/* Buddhist Funeral Procedures */}
            <div className="funeral-information-religious-section">
              <h2 className="funeral-information-religious-section-title">불교식 장례절차</h2>
              <div className="funeral-information-religious-section-content">
                <p className="funeral-information-religious-intro">
                  불교 의례 규범인 석문의범(釋門儀範)에 따르면 장례를 다비(茶毗)라고 하여 화장으로 치른다. 영결식은 일정한 순서에 따라 행한다.
                </p>
                <ol className="funeral-information-religious-procedure-list">
                  <li>
                    <strong>개식(開式)</strong>
                    <span>호상(護喪)이 한다.</span>
                  </li>
                  <li>
                    <strong>삼귀의례(三歸儀禮)</strong>
                    <span>주례승이 하며 불(佛), 법(法), 승(僧)의 세가지 귀한 것(三寶)에 돌아가 의지한다는 불교의식이다.</span>
                  </li>
                  <li>
                    <strong>약력보고</strong>
                    <span>추모의 뜻으로 고인과 생존 시 가까웠던 친구가 한다.</span>
                  </li>
                  <li>
                    <strong>착어(着語)</strong>
                    <span>주례승이 부처의 교법(敎法)의 힘을 빌어 고인을 안정시키는 말이다.</span>
                  </li>
                  <li>
                    <strong>창혼(唱魂)</strong>
                    <span>주례승이 요령을 흔들며 하는데, 극락세계에 가서 고이 잠들라는 뜻이다.</span>
                  </li>
                  <li>
                    <strong>헌화</strong>
                    <span>친지 대표가 영전에 꽃을 바친다.</span>
                  </li>
                  <li>
                    <strong>독경(讀經)</strong>
                    <span>주례승과 참례자 모두가 염불(念佛)을 하는데, 고인의 혼을 안정시키고 이승에서의 모든 관계를 잊고 부처님 세계에 고이 잠들라는 뜻이다.</span>
                  </li>
                  <li>
                    <strong>추도사</strong>
                    <span>일반에서 하는 것과 같다.</span>
                  </li>
                  <li>
                    <strong>소향(燒香)</strong>
                    <span>일동이 함께 향을 태우며 추모하고 애도한다.</span>
                  </li>
                  <li>
                    <strong>사홍서원(四弘誓願)</strong>
                    <span>주례승이 하며 다음과 같다.</span>
                    <ul className="funeral-information-religious-sub-list">
                      <li>중생무변서원도(眾生無邊誓願度) - 중생은 끝이 없으니 제도(濟度)하여 주기를 맹세함.</li>
                      <li>번뇌무진서원단(煩惱無盡誓願斷) - 인간의 번뇌는 끊기를 원하는 맹세.</li>
                      <li>법문무량서원학(法門無量誓원學) - 불교의 세계는 한량없으니 배우기를 원함.</li>
                      <li>불도무상서원성(佛道無上誓願成) - 불도보다 더 훌륭한 것이 없으니 불도를 이루기를 맹세코 원함.</li>
                    </ul>
                  </li>
                  <li>
                    <strong>폐식선언</strong>
                    <span>영결식 후 장지로 향한다.</span>
                    <p className="funeral-information-religious-detail">
                      화장이 끝날 때까지 염불을 하며, 화장이 끝나면 주례승이 흰 창호지에 유골을 받아 상제에게 주면, 쇄골 후 절에 봉안하고 제사를 지낸다. 제의(祭儀)로는 49재, 백일제, 3년상을 지낸다.
                    </p>
                    <p className="funeral-information-religious-detail">
                      또 고인의 생일을 맞으면 추도식을 갖기도 한다. 준비하고 진행한다. 상기가 끝난 뒤 복(服)을 벗는 절차이다. 탈상은 부모 조부모 배우자의 경우, 별세한 날로부터 100일까지이고 그 밖의 경우는 장례일까지이다. (가정의례준칙) 이때 지내는 제사가 탈상제인데, 제사 지내는 방법은 기제(忌祭)와 동일하다.
                    </p>
                  </li>
                </ol>
              </div>
            </div>

            {/* Christian Funeral Procedures */}
            <div className="funeral-information-religious-section">
              <h2 className="funeral-information-religious-section-title">기독교식 장례절차</h2>
              <div className="funeral-information-religious-section-content">
                <p className="funeral-information-religious-intro">
                  처음부터 끝까지 목사의 집례 하에 진행된다. 임종 시에는 구원의 확신을 갖고 믿음으로 하나님의 나라에 이르도록 도우며 임종 시부터 고인의 영혼을 찬송과 기도 속에 하나님께 맡기는 예배를 드리고 유가족은 빈소에서 기도회를 가지며 찬송이 그치지 않게 한다. 일반 장례식과는 달리 곡을 하지 않고 음식을 차리지 않으며 절도 하지 않는다. 또한 분향을 하지 않고 헌화를 한다. 장례일은 전통적으로 홀수(3, 5, 7일장)로 하여 근래에는 3일장이 일반적이나 교회에서는 이러한 일수에 얽매일 필요는 없으면 주일이 겹칠 때에는 2일 혹은 4일장으로 하기도 한다.
                </p>
                <ol className="funeral-information-religious-procedure-list second-list">
                  <li>
                    <strong>임종예배</strong>
                    <span>성도가 임종이 임박하면 가장 먼저 담임목사에게 연락하도록 하고 임종하면 임종예배를 드리고 장례일정 및 제반사항을 의논한다. 곡은 하지 않고 제사상도 차리지 않으며 경건하게 장례를 준비하고 진행한다.</span>
                  </li>
                  <li>
                    <strong>입관예배</strong>
                    <span>목사의 집례하에 유족이 고인의 모습을 지켜보는 가운데 염습을 하고 입관을 마친 후 입관예배를 드린다. 상복은 남자는 검은색 계통의 양복에 완장을 착용하고 여자는 흰색이나 검정색 치마저고리로 복장을 통일한다.</span>
                  </li>
                  <li>
                    <strong>조문맞이</strong>
                    <span>기독교식 장례에서는 분향을 하지 않고 헌화를 한다. 그러므로 일반 조문객들을 위해 헌화할 꽃을 빈소 입구에 준비해 두는 것이 좋다. 간혹 일반 조문객들을 감안하여 분향을 할 수 있도록 준비하기도 한다.</span>
                  </li>
                  <li>
                    <strong>발인(출관)예배</strong>
                    <span>하나님께 영광을 돌리고 유족에게는 위로와 소망을 주며, 조객들에게 하나님의 사랑과 공의를 알게 한다.</span>
                  </li>
                  <li>
                    <strong>영결식순</strong>
                    <span></span>
                    <ul className="funeral-information-religious-sub-list">
                      <li>개식사 - 주례목사</li>
                      <li>신앙고백 및 찬송 - 사도신경, 찬송(534장)을 다같이 한다.</li>
                      <li>기도 - 고인의 명복과 유족에게 위로를 내리시길 기원한다.</li>
                      <li>성경봉독 - 고린도후서 5장 1절, 디모데전서 6장 7절 등을 낭독.</li>
                      <li>기도 및 위로의 말씀</li>
                      <li>약력보고 - 유가족 대표나 교회 대표.</li>
                      <li>찬송 및 주기도문</li>
                      <li>출관</li>
                    </ul>
                  </li>
                  <li>
                    <strong>하관</strong>
                    <span>목사의 주례 하에 신앙고백과 성경낭독, 그리고 하나님으로부터 왔다가 다시돌아감을 선언하고, 고인의 명복을 비는 기도와 찬송을 하며 축도 순으로 식을 진행한다.</span>
                    <p className="funeral-information-religious-detail">
                      찬송 속에 헌화와 취토를 하고 성분을 한다. 기독교식이라 하여꼭 매장하여야 하는 것은 아니며 화장도 교리에 어긋나지 않는다. 실제로 교회나 기독교인들의 화장도 점차 증가하고 있는 추세이다.
                    </p>
                  </li>
                </ol>
              </div>
            </div>

            {/* Catholic Funeral Procedures */}
            <div className="funeral-information-religious-section">
              <h2 className="funeral-information-religious-section-title">천주교식 장례절차</h2>
              <div className="funeral-information-religious-section-content">
                <p className="funeral-information-religious-intro">
                  장례 생전에 영세를 받은 사람은 '성교예규 (聖敎禮規)'에 의해 장례를 치른다. 천주교나 기독교라 하더라도 신앙에서 벗어나지 않는 범위 내에서 전통의 관습이나 의식을 병행하기도 한다.
                </p>
                <ol className="funeral-information-religious-procedure-list third-list">
                  <li>
                    <strong>임종 전</strong>
                    <span>가능하면 정신이 맑을 때 미리 세례를 받거나 영세를 받을 의사를 타진하여 시행하는 것이 좋다. 임종이 임박하여 급히 세례를 받고자 하나, 신부를 모셔올 여유가 없으면 교우회장이나 수녀로부터 대신 세례를 받을 수 있다. 임종이 예견되면 탁자에 백지나 백포를 깔고 십자고상(十字苦像)과 촛대 두 개, 성수 그릇과 성수채를 준비해 두고 미리 선부에게 연락을 취한다.</span>
                  </li>
                  <li>
                    <strong>종부성사(終傅聖事)</strong>
                    <span>운명할 때 행하는 성사로 가족들은 미리 환자의 눈, 코, 입, 손과 발을 씻기고신부에게 고해성사를 할 수 있도록 모두 물러난다. 고해성사가 끝나면 신부는 종부성사를 행한다. 임종시 신부가 없을 경우에는 주위 가족들이 위로와 격려의 말을 들려주고 성서 가운데 거룩한 구절을 읽어 준다.</span>
                  </li>
                  <li>
                    <strong>운명</strong>
                    <span>운명 시에는 성초에 불을 켜고 임종경(臨終經)이나 성모덕서도문, 매괴경 등을 읽는다. 운명한 뒤에도 얼마 동안 계속해 주며 편안함 임종을 위해 거룩한 기도문이나 성가를 들려준다. 환자가 운명하면 눈과 입을 다물게 하고 두 손을 합장시켜 십자고상을 쥐어 준다. 상위에 고상을 모시고 좌우에 촛불을 켜며 성수와 성수채를 입관 때까지 놓아둔다. 가족들은 그 옆에 꿇어 앉아 연도(煉禱)한다. 염경이 끝날 때마다 성수를 뿌리며 만 하루가 지나면 정해진 경을 외고 시신을 닦고 수의를 입혀 입관한다.</span>
                  </li>
                  <li>
                    <strong>위령미사(연미사)</strong>
                    <span>연옥에 있는 사람을 위해 천주께 올리는 제사의 의미로 임종시 본당 신부에게 곧바로 알려 미사 예물을 전하고 미사를 청하여 장례일과 미사일정 등을 의논하여 결정한다.</span>
                  </li>
                  <li>
                    <strong>장례식</strong>
                    <span>목사의 주례 하에 신앙고백과 성경낭독, 그리고 하나님으로부터 왔다가 다시 돌아감을 선언하고, 고인의 명복을 비는 기도와 찬송을 하며 축도 순으로 식을 진행한다. 찬송 속에 헌화와 취토를 하고 성분을 한다. 기독교식이라 하여 꼭 매장하여야 하는 것은 아니며 화장도 교리에 어긋나지 않는다. 실제로 교회나 기독교인들의 화장도 점차 증가하고 있는 추세이다.</span>
                  </li>
                  <li>
                    <strong>하관</strong>
                    <span>장지에 도착하면 묘지 축성기도를 하고 영구와 천광에 성수를 뿌리고 하관기도를 한 후 하관한다.</span>
                  </li>
                  <li>
                    <strong>장례 후</strong>
                    <span>3일, 7일, 30일, 소상과 대상 때에 연미사를 올리고 가족의 고해, 영성체를 행한다. 천주교 상례에서도 신앙에 어긋나지 않는 범위에서 간소한 음식을 접대하거나 묘소를 찾고 성묘하는 것 등은 예전부터 행하여 왔다.</span>
                  </li>
                </ol>
              </div>
            </div>

          </div>
        </div>
      </main>

    </div>
  );
};

export default FuneralInformationReligiousPC; 